export default "__VITE_ASSET__10e371fc__"